import React from 'react'
import MarketCard from './MarketCard'

const AllFont = () => {
  const obj = require('../../font.json')
  return (
    <>
      {obj.map((value, i) => (
        <MarketCard key={i} value={value} variant="font" category="font" />
      ))}
    </>
  )
}

export default AllFont
